export type FiltersState = Record<string, unknown>

export enum EFiltersActions {
    SET_FILTER = 'setFilter'
}

export enum EFiltersMutations {
    SET_FILTERS = 'setFilters'
}
